import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBannerSharedComponent } from './app-banner.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { ImgServiceDirectiveModule } from '../../../shared/directive/img.service/img.service.module';

@NgModule({
    declarations: [
        AppBannerSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        ImgServiceDirectiveModule
    ],
    exports: [
        AppBannerSharedComponent
    ]
})
export class AppBannerSharedModule {}
